module.exports = __webpack_public_path__ + "3d432712f67a43ee84c0fb507002d6b1.png";